import { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { DispatchContext } from '../../App';

import { setLanguage } from '../../functions/functions';

import './LangList.css';


const LANGS = [
    {
        id: 'ita',
        name: 'italiano'
    },
    {
        id: 'eng',
        name: 'english'
    },
    {
        id: 'deu',
        name: 'deutsch'
    },
    {
        id: 'esp',
        name: 'español'
    },
    {
        id: 'fra',
        name: 'francais'
    }
];
    


const LangList = ({ toggleIsMouseOver }) => {
    const dispatch = useContext(DispatchContext);
    const selectLanguage = (langID) => {
        setLanguage(dispatch, langID);
        toggleIsMouseOver();
    };

    return (
        <div 
            className='langlist-container shadow'
            onMouseLeave={() => toggleIsMouseOver() }
        >
            <span className='langlist-note' >
                <FormattedMessage 
                    id='select_language'
                    defaultMessage='Seleziona la lingua'
                />
            </span>
            <ul className='langlist'>
                {
                    LANGS.map(lang => {
                        return (
                            <li 
                                className='langlist-item'
                                key={lang.id}
                            >
                                <button 
                                    className='header-btn langlist-item'
                                    onClick={() => selectLanguage(lang.id)}
                                >
                                    { lang.name }
                                </button>
                            </li>
                        )
                    })
                }
            </ul>
        </div>
    )
};

export default LangList;